import { DropType, Select, SelectProps, Text } from 'grommet'
import { useMemo, useState } from 'react'
import { getRegExp } from '../../../utils'
import './style.css'

interface SearchableProps extends SelectProps {
  options: any[]
  label?: string
  value: any
  getLabel?: string
  setOptions?: (e: any) => void
  setValue: (e: any) => void
  create?: boolean
  onSearch?: (e: string) => void
  dropProps?: DropType
  style?: React.CSSProperties
  className?: string
}

const prefix = 'Create'

export const SearchInput = ({
  options,
  value,
  setValue,
  setOptions,
  getLabel,
  create,
  dropProps,
  onSearch,
  label,
  style,
  className,
  ...rest
}: SearchableProps) => {
  const [searchValue, setSearchValue] = useState('')

  const defaultOptions = useMemo(() => options?.map(item => item), [options])

  const updateCreateOption = (text: string) => {
    const len = defaultOptions?.length
    if (defaultOptions[len - 1]?.includes(prefix)) {
      // remove Create option before adding an updated one
      defaultOptions.pop()
    }
    defaultOptions.push(`${prefix} '${text}'`)
  }

  if (create) {
    return (
      <Select
        height="inherit"
        icon={false}
        onChange={({ option }) => {
          if (option?.includes(prefix)) {
            defaultOptions.pop()
            defaultOptions.push(searchValue)
            setValue(searchValue)
          } else {
            setValue(option)
          }
        }}
        onClose={() => setOptions && setOptions(defaultOptions)}
        onSearch={text => {
          updateCreateOption(text)
          const exp = getRegExp(text)
          setOptions && setOptions(defaultOptions.filter(o => exp.test(o)))
          setSearchValue(text)
        }}
        options={options}
        style={{ textTransform: 'capitalize', ...style }}
        value={value}
        width="100%"
        {...rest}
      />
    )
  }

  if (onSearch) {
    return (
      <Select
        dropProps={{ ...dropProps }}
        height="inherit"
        onChange={({ option }) => {
          setValue(option)
        }}
        onSearch={onSearch}
        options={options}
        style={{ textTransform: 'capitalize' }}
        value={value}
        width="100%"
        {...rest}
      />
    )
  }

  return (
    <>
      <Text margin={{ bottom: '2px' }} style={{ fontSize: '14px', fontWeight: 500 }}>
        {label}
      </Text>
      <Select
        className={className}
        dropProps={{ ...dropProps }}
        height="inherit"
        id="search_input"
        onChange={({ option }) => {
          setValue(option)
        }}
        options={options}
        value={value}
        width="100%"
        {...rest}
      />
    </>
  )
}
